import { get } from 'lodash'
import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import {ChainingUserPreferenceDto} from '../types/ChainingUserPreference/ChainingUserPreferenceDto'

export class ChainingUserPreferenceApiAdapter implements ApiDataAdapter<number> {
    public createClass(apiData: ChainingUserPreferenceDto): number {
        return get(apiData, 'id')
    }
}
